import $ from 'jquery';

export default function () {
  const saveEmailBtns = $('.settings .save-email');
  saveEmailBtns.each(function () {
    $(this).on('click', function (e) {
      const currentEmail = $(this).attr('data-email');
      const newEmail = $('input[data-email="' + currentEmail + '"]').val();

      $.ajax({
        type: "POST",
        url: "/cabinet/settings/emails/change",
        data: { currentEmail: currentEmail, newEmail: newEmail },
        success: function (data) {
          $('.settings-result').html(data.message);
          $('.settings-result').removeClass('hidden');
        }
      });
    });
  });
}
